import * as React from 'react';
import { PromoModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useDispatch, useSelector } from 'react-redux';

import { usePromoDetailsModalTrigger, usePromoDetailsConfig, usePreparedPromo, useAvailableContacts } from './hooks';
import { ActionButtonContainer } from './parts';
import { trackCianMortgageClick } from './tracking';
import { closePromoInfo } from '../../actions/promoInfo';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { selectPromoInfo } from '../../selectors/promoInfo';
import { IPromo } from '../../types/newbuilding/promos';

export const PromoDetailsContainer: React.FC = () => {
  const promo = useSelector(selectPromoInfo);
  const newbuildingId = useSelector(getNewbuildingId);

  const dispatch = useDispatch();

  const promoModalConfig = usePromoDetailsConfig();
  const preparedPromo = usePreparedPromo();
  const contacts = useAvailableContacts();

  const isStickyControls = React.useMemo(() => {
    return contacts.sellers.length + contacts.builders.length < 2;
  }, [contacts]);

  usePromoDetailsModalTrigger();

  const handleClose = React.useCallback(() => {
    dispatch(closePromoInfo());
  }, [dispatch]);

  const handleMortgageClick = React.useCallback(() => {
    trackCianMortgageClick(promo as IPromo, newbuildingId);
  }, [promo, newbuildingId]);

  if (!preparedPromo) {
    return null;
  }

  return (
    <PromoModal
      open={true}
      onOpenChange={handleClose}
      promo={preparedPromo}
      onCianMortgageClick={handleMortgageClick}
      controls={<ActionButtonContainer />}
      config={promoModalConfig}
      stickyControls={isStickyControls}
    />
  );
};
